import { ChevronRight, Link2 } from "lucide-react";

import { cn } from "@/lib/utils";
import {
  KindredSharePayload,
  getKindredShareTypeLabel,
} from "@/lib/kindredShare";
import { AppCard, AppCardBody, AppText } from "../../ui-foundation";

interface KindredShareCardProps {
  payload: KindredSharePayload;
  onOpen: () => void;
  className?: string;
}

const KindredShareCard = ({ payload, onOpen, className }: KindredShareCardProps) => (
  <button
    type="button"
    onClick={onOpen}
    className={cn(
      "mt-2 w-full text-left transition hover:-translate-y-0.5",
      className,
    )}
  >
    <AppCard>
      <AppCardBody py="$sm">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/12 text-primary">
            <Link2 size={16} />
          </span>
          <span className="min-w-0 flex-1">
            <AppText className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
              {getKindredShareTypeLabel(payload.type)}
            </AppText>
            <AppText className="mt-1 block truncate text-sm font-semibold text-foreground">{payload.title}</AppText>
            {payload.subtitle ? (
              <AppText className="mt-0.5 block truncate text-xs text-muted-foreground">{payload.subtitle}</AppText>
            ) : null}
          </span>
          <ChevronRight size={16} className="shrink-0 text-muted-foreground" />
        </div>
      </AppCardBody>
    </AppCard>
  </button>
);

export default KindredShareCard;
